import React from 'react';
import InputField from './InputField';

const HorizontalInputField = props => <InputField {...props} horizontal />;

export default HorizontalInputField;
